module.exports = __webpack_public_path__ + "img/pinterest.f2e5fbee.svg";